module.exports = {
  env: 'development',
  domain: ['v2dev.tsepcn.com'],
  mobileDomain: 'v2devh5.tsepcn.com',
  aegisId: 'akNqIsanJXJnMpAhyv',
  reportDomain: 'baike.sparta.html5.qq.com',
  cosAppId: 'tsep_dev',
  bucket: 'tsep-test-1304685099',
  region: 'ap-guangzhou',
};
